<template lang="html">
  <div class="interview-questions" v-if="!loading">
    <question v-for="question in questions"
              :validation="validation"
              :disabled="disabled"
              :id="question.id"
              :question="question.question"
              :fullQuestion="question"
              :key="question.id"
              :answeredQuestions="answeredQuestions"
              :route-upload-video="routeUploadVideo"
              @question-ready="readyQuestionHandler"
    ></question>
  </div>
</template>

<script>
// Components show list of questions on interview page

export default {
  props: ['default', 'questions', 'validation', 'routeUploadVideo', 'disabled'],
  data() {
    return {
      answeredQuestions: null,
      loading: true,
      readyQuestionsCount: 0,
    };
  },
  created() {
    this.answeredQuestions = this.default;
  },
  mounted() {
    this.checkRestoreQuestionsFromLocalStorage();
    this.loading = false;
  },
  methods: {
    processForm() {
      let submitType = localStorage.getItem('interview_submit_type');
      if (!submitType) return;

      localStorage.setItem('interview_submit_type', '');
      $(document).ready(() => {
        $('button[data-type="' + submitType + '"]').click();
      });
    },
    readyQuestionHandler() {
      this.readyQuestionsCount++;

      if (this.readyQuestionsCount == this.questions.length) {
        this.processForm();
      }
    },
    checkRestoreQuestionsFromLocalStorage() {
      let storageData = localStorage.getItem('interview');
      if (!storageData) return;

      this.restoreCoverImageData(JSON.parse(storageData));
    },

    restoreCoverImageData(storageData) {
      if (!storageData.cover || !storageData.cover.id || !storageData.cover.path) return;

      $('#file_id').val(storageData.cover.id);
      $('#cover_image').attr('src', storageData.cover.path);
      $('#cover_image').css('display', 'inline-block');
      $('.main-image').css('display', 'none');
    },
  },
};
</script>